import script from "./GiftsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GiftsList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__